<section class="calculator-section">
  <div class="container">
    <div class="calculator-layout">

      <!-- Columna IZQUIERDA: Calculadora -->
      <div class="calculator-column">
        <div class="calculator-box">
          <h3 class="calculator-title">Calculadora de descuentos</h3>

          <div class="calculator-form">

            <div class="form-group">
              <label for="amount">Importe de cheque</label>
              <input type="number" id="amount" [(ngModel)]="importeCheque" placeholder="0" class="form-input" min="1"
                (keydown)="preventInvalidChars($event)">
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="date">Fecha de vencimiento</label>
                <input type="date" id="date" [(ngModel)]="fechaVencimiento" [min]="minDate" class="form-input">
              </div>

              <div class="form-group">
                <label for="rate">Tasa de mercado (%TNA)</label>
                <input type="number" id="rate" [(ngModel)]="tasaDescuento" class="form-input" step="1" min="0" max="100"
                  placeholder="Ej: 25" (keydown)="preventInvalidChars($event)">
              </div>
            </div>

            <button class="calculate-btn" (click)="calculateDiscount()">
              Calcular
            </button>
          </div>

          <!-- Results Section -->
          @if (mostrarResultados) {
          <div class="results-section">
            <h4 class="form-section-title">Liquidación</h4>

            <div class="result-grid">
              <div class="result-row highlight">
                <span class="result-value">Monto a recibir Neto de gastos</span>
                <span class="result-value">{{ formatCurrency(importeNeto) }}</span>
              </div>

              <div class="result-row">
                <span>Comisión SGR (4% anual)</span>
                <span>{{ formatCurrency(comisionSGR) }}</span>
              </div>

              <div class="result-row">
                <span>Comisión ALyC (1% anual)</span>
                <span>{{ formatCurrency(comisionAlyC) }}</span>
              </div>

              <div class="result-row">
                <span>Derecho de Mercado</span>
                <span>{{ formatCurrency(derechoMercado) }}</span>
              </div>

              <div class="result-row highlight-costo">
                <span class="result-value">Costo Final</span>
                <span class="result-value">{{ formatCurrency(costoFinalGastos) }}</span>
              </div>

              <div class="result-row">
                <span>Tasa de descuento aplicada + gastos</span>
                <span>{{ formatPercent(tasaDescuentoAplicadaGastos) }}</span>
              </div>

              <div class="result-row">
                <span>Ahorro Imp. Deb/Cred (en caso de emitir CHPD)</span>
                <span>{{ formatCurrency(ahorroImpDebCred) }}</span>
              </div>
            </div>

            <div class="disclaimer">
              <strong>Nota:</strong> La información contenida en este simulador es de carácter meramente informativo,
              no genera a LightCap Group obligación de ningún tipo. La tasa de descuento es estimativa y dependerá
              de las condiciones del mercado al momento de concretar la operación.
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Columna DERECHA: Información -->
      <div class="info-column">
        <!-- Info Section -->
        <div class="info-section">
          <h2 class="section-title">Descuento de Cheques</h2>
          <p class="section-description">
            Calculá tus operaciones de descuento de cheques y conocé el saldo en el mercado de capitales.
            Ingresando los datos de la operación en nuestra calculadora vas a poder conocer el costo de financiamiento.
          </p>

          <h3 class="subsection-title">Financiamiento hasta 360 días</h3>
          <p class="section-description">
            LightCap Group te asesora para que descuentes cheques propios o de tus clientes en el mercado de capitales.
            Financiate hasta 360 días sin afectar tu línea crediticia bancaria.
          </p>
        </div>

        <!-- Requirements Section -->
        <div class="requirements-section">
          <h3 class="subsection-title">Requisitos</h3>

          <!-- Accordion Persona Física -->
          <div class="accordion">
            <button class="accordion-header" (click)="toggleAccordion('fisica')">
              Persona Física
              <span class="accordion-icon">{{ accordionFisica ? '−' : '+' }}</span>
            </button>
            <div class="accordion-content" [class.active]="accordionFisica">
              <ul>
                <li>DNI</li>
                <li>DDJJ de IIBB (en caso de corresponder a MONOTRIBUTO - últimos 3)</li>
                <li>DDJJ Ganancias (en caso de corresponder a RESPONSABLE INSCRIPTO)</li>
                <li>Manifestación de bienes por profesional y certificada por consejo</li>
                <li>Constancia de CBU</li>
                <li>Constancia de domicilio (ej: factura de servicio)</li>
              </ul>
            </div>
          </div>

          <!-- Accordion Persona Jurídica -->
          <div class="accordion">
            <button class="accordion-header" (click)="toggleAccordion('juridica')">
              Persona Jurídica
              <span class="accordion-icon">{{ accordionJuridica ? '−' : '+' }}</span>
            </button>
            <div class="accordion-content" [class.active]="accordionJuridica">
              <ul>
                <li>Estatuto/Contrato social</li>
                <li>DNI socios/accionistas</li>
                <li>Último balance certificado ante Consejo profesional</li>
                <li>Manifestación de bienes del socio/accionista fiador</li>
                <li>Constancia de domicilio de socio/accionista fiador (ej. factura de servicio)</li>
                <li>Constancia de CBU cuenta corriente</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<app-cta-section></app-cta-section>